import styled from "styled-components";

export const ForgetPasswordCompleteContainerStyled = styled.div`
  .title {
    margin-bottom: 10px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_11};
    font-size: ${({ theme }) => theme.FONT.SIZE.S18};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
  }
  .sub_title {
    margin-bottom: 40px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_11};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }
`;
